module.exports = __webpack_public_path__ + "static/img/51-2.21c556a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/51-2.jpg
// module id = 39eJ
// module chunks = 0